<script>
	let im = 'jaq_chartier.jpg';
</script>

<main>
  <h1>
    DeepCrystal
  </h1>

	<h2>
	  <img src={im} alt = "jaq chartier artwork">
		<h3>DeepCrystal was a silicon-valley artificial intelligence company focused on bringing advancements in
		  <a href="https://pubs.acs.org/doi/10.1021/acs.molpharmaceut.7b01144">geometric deep learning</a> to the pharmaceutical industry.
			DeepCrystal was acquired by <a href="http://www.numerate.com">Numerate</a> in the summer of 2017.
    </h3>
	</h2>

	<h4>
    COPYRIGHT © 2017 DEEPCRYSTAL TECHNOLOGIES
	</h4>
</main>


<style>
	main {
		text-align: center;
		padding: 0em;
		margin: 0 auto;
	}

	h1 {
		text-align: left;
		margin-left: 9.2%;
		padding: .1%;
		font-size: 2.0em;
		font-weight: 525;
	}

  h2 {
		background: #f7f7f7;
		padding: 4%;
	}

	h3 {
		font-size: .72em;
		font-weight: 440;
    position: center;
		padding: 1%;
	}

	h4 {
		font-size: .65em;
		font-weight: 500;
		padding: .5%;
	}

	img {
		position: center;
		max-width: 50%;
		height: auto;
    padding: 1.5%;
  }



	@media (min-width: 480px) {
		main {
			max-width: none;
		}
	}
</style>
